export default __webpack_public_path__ + "static/vifon-f5feb5341fc6963a8962a176ccaa8518.jpg";